<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <div class="container">
      <div class="breadcrumb-container">
        <router-link to="/persona">Personas</router-link>
        > {{ p_nombre }}
      </div>
<!--
      <div class="notification-area" v-for="(notificacion, index) in notificaciones" :key="index">
        <div class="notification-message" 
             :class="{ 'is-success': notificacion.type === 'success', 'is-error': notificacion.type === 'error' }">
          {{ notificacion.message }}
        </div>
      </div>
-->
    </div>
    <hr>
<!-- Modal -->
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <form>
        <div class="modal-body">
<!--
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idBitacora" class="form-label">IdBitacora</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idBitacora" name="idBitacora" v-model="datoBitacora.idBitacora" disabled>
                </div>
              </div>
            </div>
-->
<!-- Botón Lista de Valores  Persona -->
<!--
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoBitacora.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->
<!-- Botón Lista de Valores  Persona -->
<!-- Botón Lista de Valores  Medio Com -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-1">
                    <label for="idMedioCom" class="form-label">Medio</label>
                  </div>
                  <div class="col-11">
                    <select class="form-control" id="idMedioCom" name="idMedioCom" v-model="datoBitacora.idMedioCom">
                      <option v-for="medioCom in medioComs" :value="medioCom.idMedioCom" :key="medioCom.idMedioCom">
                        {{ medioCom.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Medio Com -->
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <label for="texto" class="form-label">Texto</label>
                </div>
                <div class="col-11">
                  <div class="textarea-container-mic">
                    <textarea class="form-control" id="texto" name="texto" v-model="datoBitacora.texto" rows="10" style='text-transform:uppercase'></textarea>
                      <div class="buttons-container-mic">
                        <button v-if="!isDictating" @click="startDictation" type="button" class="btn btn-light" title="Iniciar Dictado">
                          <span class="material-symbols-outlined" style="font-size:40px;color:orangered; cursor: pointer;">mic_off</span>
                        </button>
                        <button v-else @click="stopDictation" type="button" class="btn btn-light" title="Finalizar Dictado">
                          <span class="material-symbols-outlined" style="font-size:40px;color:green; cursor: pointer;">mic</span>
                        </button>
                      </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarBitacora" title="Guardar">
          <i class="material-icons" style="font-size:20px;color:green; cursor: pointer;">save</i> Guardar
        </button>
      </div>
    </div>
  </div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import SpeechDictation from '@/modules/microfono.js';
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      bitacoras : [],
      datoBitacora : {},
      nombreBusqueda: '',
      titulo: '',
      modalWindow: true,
      p_idBitacora: 0,
      personas: [],
      medioComs: [],
      dictation: new SpeechDictation(),
      isDictating: false,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.p_idPersona = this.$route.params.p_idpersona
    this.p_nombre = this.$route.params.p_nombre
//    this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
//    this.fetchPersonas()
    this.fetchMedioComs()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
/*
   getData() {
      api.get('/vwbitacoras/'+this.p_idBitacora)
        .then(response => {
          this.datoBitacora = response.data;
        })
        .catch(error => {
         console.error('Error al obtener datos de la persona:', error);
        });
    },
*/
validarForm(){
      const requiredFields = [
        'idMedioCom'
        ,'texto'
      ];
      const requiredFieldsText = [
        'idMedioCom'
        ,'texto'
      ];
      return validarForm(this.datoBitacora, requiredFields, requiredFieldsText);
    },
    async guardarBitacora(){
      if(this.validarForm() === 1){
        try {
          this.datoBitacora.idPersona = this.p_idPersona;
          await api.post('/bitacoras', this.datoBitacora)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Bitacora creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },    
/*     fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    }, */
    startDictation() {
      this.isDictating = true;
      this.dictation.startDictation((transcript) => {
        this.datoBitacora.texto = transcript;
      }, this.datoBitacora.texto);
    },
    stopDictation() {
      this.isDictating = false;
      this.dictation.stopDictation();
    },
    fetchMedioComs() {
      fetch('http://localhost:8080/api/v1/mediocoms')
        .then(response => response.json())
        .then(data => {
          this.medioComs = data;
        })
        .catch(error => {
          console.error('Error fetching medioComs:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
<style src="@/assets/css/microfono.css" scoped></style>